import { useRef } from "react";
import { createContext, useContext, useState, useEffect } from "react";
import { useUserStore } from "./useUserStore"; // We rely on user info & token
import SpecificAPI from "../services/SpecificApi";

const PromptCategoriesContext = createContext(null);

export const PromptCategoriesProvider = ({ children }) => {
  const hasLoadedRef = useRef(false);
  const { isAppUserLoading, appUser } = useUserStore();

  const [promptCategories, setPromptCategories] = useState([]);
  const [isPromptCategoriesLoading, setIsPromptCategoriesLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isAppUserLoading) return;

    // 🔁 reset on logout
    if (!appUser) {
      hasLoadedRef.current = false;
      setPromptCategories([]);
      setIsPromptCategoriesLoading(false);
      return;
    }

    // 🛑 fetch once
    if (hasLoadedRef.current) return;
    hasLoadedRef.current = true;

    const loadPromptCategories = async () => {
      try {
        setIsPromptCategoriesLoading(true);

        let data = [];
        if (appUser.role !== "student") {
          const response = await SpecificAPI.getPromptCategories({});
          data = response || [];
        }

        setPromptCategories(data);
      } catch (err) {
        console.error("Failed to load prompt categories:", err);
        setError(err);
      } finally {
        setIsPromptCategoriesLoading(false);
      }
    };

    loadPromptCategories();
  }, [appUser, isAppUserLoading]);

  return (
    <PromptCategoriesContext.Provider
      value={{
        promptCategories,
        isPromptCategoriesLoading,
        error,
        setPromptCategories,
      }}
    >
      {children}
    </PromptCategoriesContext.Provider>
  );
};

export const usePromptCategoriesStore = () =>
  useContext(PromptCategoriesContext);
